import React from 'react';
import {Row, Col } from 'react-bootstrap';
import { Button } from '@mui/material';
import './ProductPolicyCost.scss';

export default function ProductPolicyCost(props) {

  return (
    <Row className="policy-cost" id="policy-cost">
        <Row className="m-0 px-0">
          <Col className={`hero-background-image text`} style={{'--props-data-image': `url(${props.data.image})`}}>
              <div className='policy-cost-contain'>
                <h2 className={`heading-text ${props.data.text.largeText ? "large-text" : ""}`}>{props.data.text.title}</h2>
                {props.data.text.paragraphs && props.data.text.paragraphs.map((p, i) => {
                  return <p className="text-start policy-cost-discription" key={i}>{p}</p>
                })}
                <Button variant="contained" color="primary" type="submit" fullWidth className='policy-cost-submit-button' onClick={props.action}>{props.data.callToActionText || "GET YOUR QUOTE"}</Button>
              </div>
          </Col>
        </Row>
    </Row>
  );
}
